import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronEndLeftIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M13.5,0 L15,1.5 L9,7.5 L15,13.5 L13.5,15 L6,7.5 L13.5,0 Z M3,0 L3,15 L1,15 L1,0 L3,0 Z"
        data-testid="icon-chevronEndLeft"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
